/* O quadro kanban: colunas, cartões e o arrastar-e-soltar.
   No celular o arrastar é ruim, por isso cada cartão tem as setas ‹ ›. */
import { $, $$, esc, dataBR, dias, idade } from "../util.js";
import { S, visiveis } from "../estado.js";
import { MAPA } from "../dados/especies.js";
import { ETAPAS, DOCS } from "../dados/etapas.js";
import { BENEF, progresso } from "../dados/catalogo.js";
import { mover, mudarEtapa } from "../api/casos.js";
import { abrirFicha } from "./ficha.js";
import { abrirPix } from "./pix.js";
import { toast } from "../util.js";
import { desenhar } from "../render.js";

export function renderQuadro(){
  /* Captador que ainda não cadastrou nada: cinco colunas escritas "Nada aqui"
     não ensinam nada a quem está começando. No lugar delas, o caminho.
     A checagem é em S.casos, não na lista filtrada: filtro escondendo cartão
     é outra coisa, e ali o quadro normal tem que aparecer. */
  if(!S.souAdmin && !S.casos.length){ primeirosPassos(); return; }

  const lista=visiveis(MAPA), board=$("#board");
  board.className="board";
  board.innerHTML=ETAPAS.map(et=>{
    const itens=lista.filter(c=>c.etapa===et.id);
    return `<div class="col" data-etapa="${et.id}" style="--c:${et.cor}">
      <div class="col-head"><div class="col-title"><span>${et.nome}</span><span class="col-count">${itens.length}</span></div></div>
      <div class="col-body" data-drop="${et.id}">${itens.length?itens.map(cardHTML).join(""):`<div class="col-empty">Nada aqui</div>`}</div></div>`;
  }).join("");
  ligarDnD(board,true);
}

/* Primeiros passos de quem acabou de entrar. */
function primeirosPassos(){
  const temPix=!!S.perfil?.pix, board=$("#board");
  board.className="board passos";
  board.innerHTML=`<div class="passos-cx">
    <h2>Boas vindas. São quatro passos até a primeira procuração.</h2>
    <p class="hint">Cada caso que você cadastrar aparece aqui, e caminha da esquerda para a direita conforme anda.</p>
    <ol class="passos">
      <li class="${temPix?"ok":""}">
        <b>Cadastre sua chave PIX</b>
        <span>${temPix
          ? "Feito. É para onde a sua comissão vai."
          : "É para onde a sua comissão vai. Sem a chave, o escritório não tem como pagar você."}</span>
        ${temPix?"":`<button class="acao" id="ppPix">Cadastrar chave</button>`}
      </li>
      <li>
        <b>Cadastre o primeiro cliente</b>
        <span>Nome, contato e o benefício que ele procura. Dá para completar o resto depois.</span>
        <button class="btn" id="ppNovo">+ Novo caso</button>
      </li>
      <li>
        <b>Escaneie os documentos</b>
        <span>Pela câmera do celular, dentro da ficha do caso. A foto é tratada e comprimida sozinha, então funciona mesmo com internet ruim.</span>
      </li>
      <li>
        <b>Colha a assinatura</b>
        <span>Quando a documentação fecha, a procuração sai preenchida e o cliente assina na tela, ali mesmo.</span>
      </li>
    </ol>
  </div>`;
  const bPix=$("#ppPix");
  if(bPix) bPix.onclick=()=>abrirPix();
  $("#ppNovo").onclick=()=>abrirFicha();
}
export function cardHTML(c){
  const esp=MAPA[c.codigo], n=dias(c.entrada), d=DOCS[c.doc]||DOCS.nao;
  const i=ETAPAS.findIndex(e=>e.id===c.etapa), et=ETAPAS[i<0?0:i];
  const nAx=(c.anexos||[]).length;
  return `<article class="card" draggable="true" data-id="${c.id}" style="--c:${et.cor}">
    <div class="card-name">${esc(c.cliente)}</div>
    ${c.codigo?`<span class="code${esp&&!esp.ativo?" ext":""}">${c.codigo}</span>`:""}
    <div class="case-name">${esc(BENEF[c.beneficio]?.nome || (esp?esp.nome:"Benefício não definido"))}</div>
    ${(()=>{const pr=progresso(c);return pr.total?`<div class="barra" style="margin:2px 0 7px"><i style="width:${pr.pct}%;background:${pr.pct===100?"var(--conc)":"var(--doc)"}"></i></div>`:"";})()}
    <div class="card-foot">
      <span class="age ${idade(n)}">${n==null?"sem data":n+"d"}</span>
      <span>${dataBR(c.entrada)}</span>
      <span style="display:inline-flex;align-items:center;gap:5px"><i class="dot" style="background:${d.cor}"></i>${d.rot}</span>
      ${nAx?`<span class="clip">&#128206; ${nAx}</span>`:""}
    </div>
    <div class="cap"><span>${S.souAdmin?`Captador: <b>${c.captador?esc(c.captador):"não informado"}</b>`:`Entrada em <b>${dataBR(c.entrada)}</b>`}</span>
      <span class="mv">
        <button data-mv="-1" ${i<=0?"disabled":""} aria-label="Voltar etapa">&#8249;</button>
        <button data-mv="1" ${i>=ETAPAS.length-1?"disabled":""} aria-label="Avançar etapa">&#8250;</button>
      </span></div></article>`;
}
let arrastando=null;
export function ligarDnD(raiz,comDrop){
  raiz.querySelectorAll(".card").forEach(el=>{
    if(comDrop){
      el.addEventListener("dragstart",e=>{ arrastando=el.dataset.id; el.classList.add("dragging"); e.dataTransfer.effectAllowed="move"; e.dataTransfer.setData("text/plain",el.dataset.id); });
      el.addEventListener("dragend",()=>{ el.classList.remove("dragging"); arrastando=null; $$(".col.over").forEach(c=>c.classList.remove("over")); });
    } else el.setAttribute("draggable","false");
    el.addEventListener("click",e=>{
      const mv=e.target.closest("[data-mv]");
      if(mv){ e.stopPropagation(); mover(el.dataset.id,+mv.dataset.mv); return; }
      abrirFicha(el.dataset.id);
    });
  });
  if(!comDrop) return;
  raiz.querySelectorAll("[data-drop]").forEach(z=>{
    const col=z.closest(".col");
    z.addEventListener("dragover",e=>{ e.preventDefault(); e.dataTransfer.dropEffect="move"; col.classList.add("over"); });
    z.addEventListener("dragleave",e=>{ if(!z.contains(e.relatedTarget)) col.classList.remove("over"); });
    z.addEventListener("drop",async e=>{
      e.preventDefault(); col.classList.remove("over");
      const id=arrastando||e.dataTransfer.getData("text/plain");
      const c=S.casos.find(x=>x.id===id);
      if(!c||c.etapa===z.dataset.drop) return;
      const antes=c.etapa; c.etapa=z.dataset.drop; desenhar();
      const {error}=await mudarEtapa(id,z.dataset.drop);
      if(error){ c.etapa=antes; desenhar(); toast("Não deu para mover"); }
    });
  });
}
